import * as React from 'react';

import './planner.scss';




export interface IProps{
    TaskDetails;
    text;
}
//checklist;
export interface IContextualMenuState {
  isOpen:boolean;
}




export default class TaskCheckList extends React.Component<IProps,IContextualMenuState>{
  
  //private _menuButtonElement: HTMLElement | null;
  constructor(props: IProps) {
    super(props); 
    this.state = {
        isOpen: false
    };     
  }
  private closeopen=(e)=>{
    this.setState({isOpen:!this.state.isOpen});
  }
  //UserEmail.split("@")[1]
  public render() {    
    const { isOpen} = this.state;
    let chcklists=null;
    if(isOpen){
        chcklists=[<div style={{marginTop:'10px'}}></div>];
        Object.keys(this.props.TaskDetails.checklist).map((key)=> {
            if(this.props.TaskDetails.checklist[key].isChecked){
                chcklists.push(<div style={{textDecoration:'line-through'}}>
                <i className={["ms-Icon ms-Icon--CheckboxComposite",'detailbodyicon'].join(' ')}></i>
                  {this.props.TaskDetails.checklist[key].title}                  
                <div style={{clear:'both',marginBottom:'10px'}}></div>
            </div>); 
            }
            else{
                chcklists.push(<div>
                    <i className={["ms-Icon ms-Icon--Checkbox",'detailbodyicon'].join(' ')}></i>
                      {this.props.TaskDetails.checklist[key].title}                      
                    <div style={{clear:'both',marginBottom:'10px'}}></div>
                </div>); 
            }
                
                
            
        });
    }
    return (
           <div style={{cursor:'pointer'}} onClick={this.closeopen}>
           <div>
               <i style={{color: 'white',background: 'green'}} className={["ms-Icon ms-Icon--CheckboxComposite",'detailbodyicon'].join(' ')}>  </i> {this.props.text}                <i className={["ms-Icon ms-Icon--ChevronRightSmall",'expandicon'].join(' ')}></i>
               <div style={{clear:'both'}}></div>
           </div>
           {chcklists}
            
           </div>
     );
  }
  

     

}
